import { createAction } from '@reduxjs/toolkit';

export const setSelectedFloorplanId = createAction(
  'floorplans/setSelectedFloorplanId'
);

export const setFloorplanSelectionRect = createAction(
  'floorplans/setFloorplanSelectionRect'
);
